import { render, staticRenderFns } from "./resetPasswordSuccess.vue?vue&type=template&id=412faeb4&scoped=true&"
import script from "./resetPasswordSuccess.vue?vue&type=script&lang=js&"
export * from "./resetPasswordSuccess.vue?vue&type=script&lang=js&"
import style0 from "./resetPasswordSuccess.vue?vue&type=style&index=0&id=412faeb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412faeb4",
  null
  
)

export default component.exports